var stdin_default = {
  CONFIRM: "\u786E\u5B9A",
  TODAY: "\u4ECA\u5929",
  WEEK: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
  MONTH: [
    "1\u6708",
    "2\u6708",
    "3\u6708",
    "4\u6708",
    "5\u6708",
    "6\u6708",
    "7\u6708",
    "8\u6708",
    "9\u6708",
    "10\u6708",
    "11\u6708",
    "12\u6708"
  ],
  DEFAULT_DATE_FORMAT: "YY\u5E74MM\u6708DD\u65E5",
  DEFAULT_YEAR_MONTH_FORMAT: "YY\u5E74MM\u6708",
  DEFAULT_TIME_FORMAT: "hh:mm"
};
export {
  stdin_default as default
};
